import { createRouter, createWebHistory } from 'vue-router'
import  routes  from './routes'
import { useAuthStore } from '@/stores/auth'
import { filterAsyncRoutes } from '@/utils/router'
import { addRoutes } from '@/utils/router'

const router = createRouter({
    history: createWebHistory(),
    routes: routes.constantRoutes,
})
  
  // 动态添加路由
export function resetRouter() {
    const auth = useAuthStore()
    auth.setHasRoutes(true);
    const accessibleRoutes = filterAsyncRoutes(routes.asyncRoutes)
    addRoutes(accessibleRoutes)
}
  
  // 路由守卫
router.beforeEach(async (to, from, next) => {
    console.log('router.beforeEach', to, from);
    const auth = useAuthStore()
    document.title = to.meta.title || 'TIANYU'
    if (to.meta.requiresAuth && !auth.token) {
      next({ path: '/login', query: { redirect: to.fullPath }, replace: true })
      return
    }
    // 添加动态路由
    if (!auth.hasRoutes) {
        resetRouter()
        console.log('路由已更新');
        next()
    }else {
        next()
    }
})

export default router